module.exports = __webpack_public_path__ + "media/images/chart_big-7fca89d0a1007865b4e995ffc303a2e2.jpg";